import { useAxios } from "@hooks"
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ExamInstanceTree } from "@types";

export const useGetExamInstanceTree = (id?: string) => {

    const axios = useAxios();
    const { t } = useTranslation();
    
    const getExamInstanceTree = async () => {
        try {
            const response = await axios.get<ExamInstanceTree>(`/api/examinstance/tree/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.getExamPeriod"));
        }
    }

    return useQuery({queryKey: ["examInstanceTree", id] , queryFn: getExamInstanceTree, staleTime: Infinity });
}